import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendLongFormAsset,
  BackendMutationDeleteLongFormAssetsArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation DeleteLongFormAssets($longFormAssetIds: [ID!]!) {
    deleteLongFormAssets(longFormAssetIds: $longFormAssetIds) {
      id
    }
  }
`;

export const deleteLongFormAssets = async (
  variables: BackendMutationDeleteLongFormAssetsArgs
): Promise<Pick<BackendLongFormAsset, 'id'>[] | undefined> => {
  const response = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Pick<BackendLongFormAsset, 'id'>[]>(response.data);
};
